import { useState } from 'react';
import { Button } from '@meitu/saas-ui';
import { useTemplateModel } from '@/store/models/template-model';
import PreviewModel from './preview-model';

const PreviewBtn = () => {
    const [showModel, setShowModel] = useState(false);
    const qrCode = useTemplateModel((state) => state.qrCode);

    const showPreview = async () => {
        setShowModel(true);
    };

    return (
        <div style={{ marginRight: '10px' }}>
            {showModel ? (
                <PreviewModel
                    url={qrCode || ''}
                    closeModel={() => {
                        setShowModel(false);
                    }}
                />
            ) : null}
            <Button type="primary" data-blue onClick={showPreview}>
                预览
            </Button>
        </div>
    );
};

export default PreviewBtn;
